"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var LEFT = exports.LEFT = 37;
var UP = exports.UP = 38;
var RIGHT = exports.RIGHT = 39;
var DOWN = exports.DOWN = 40;
var ENTER = exports.ENTER = 13;
var SPACE = exports.SPACE = 32;
var ESC = exports.ESC = 27;
//# sourceMappingURL=keys.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-day-picker/lib/src/keys.js
// module id = 1802
// module chunks = 0